import(/* webpackMode: "eager" */ "/app/apps/frontend/app/global-error.tsx");
